import "client-only";

import { auth } from "./auth";
import { backtests } from "./backtests";
import { charts } from "./charts";
import { strategies } from "./strategies";
import { tasks } from "./tasks";

export {
  AUTHENTICATION_REQUIRED_EVENT,
  PlatformApiError,
} from "@/lib/platform/client";

export const api = {
  auth,
  backtests,
  charts,
  strategies,
  tasks,
} as const;
